import {
	EventCategoryRequestV7x0,
	EventTypeRequestV7x0,
} from '../../../api/generated/cz.partners.pid.backofficegateway.events';

export const EVENT_CATEGORY = {
	CLIENT: EventCategoryRequestV7x0.CLIENT,
	INTERNAL_APPLICATION: EventCategoryRequestV7x0.INTERNAL_APPLICATION,
	MOBILE_APPLICATION: EventCategoryRequestV7x0.MOBILE_APPLICATION,
	COMMUNICATION: EventCategoryRequestV7x0.COMMUNICATION,
	ALL: 'ALL',
} as const;

export const NO_EVENT_TYPE_CHOSEN = {
	NO_EVENT_TYPE_CHOSEN: 'NO_EVENT_TYPE_CHOSEN',
} as const;

export type ExtendedEventType =
	| EventTypeRequestV7x0
	| (typeof NO_EVENT_TYPE_CHOSEN)[keyof typeof NO_EVENT_TYPE_CHOSEN];

export const ExtendedEventType = {
	...EventTypeRequestV7x0,
	...NO_EVENT_TYPE_CHOSEN,
} as const;
